"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getMinGasLimit = void 0;
const networks_1 = require("@hop-protocol/core/networks");
function getMinGasLimit(network, chain) {
    var _a;
    const networkObj = networks_1.networks[network];
    const chainObj = networkObj[chain];
    return (_a = chainObj === null || chainObj === void 0 ? void 0 : chainObj.txOverrides) === null || _a === void 0 ? void 0 : _a.minGasLimit;
}
exports.getMinGasLimit = getMinGasLimit;
